<template>
  <div id="app">
    <Alert v-if="getError" type="error" :text="getError"/>
    <Alert v-if="getWarning" type="warning" :text="getWarning"/>
    <Alert v-if="getSuccess" type="success" :text="getSuccess"/>
    <Tutorial v-if="getState"/>
    <transition name="fade" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from './components/Alert'
import Tutorial from './components/Tutorials/Tutorial'

export default {
  name: 'App',
  components: {
    Alert,
    Tutorial
  },
  computed: {
    ...mapGetters('alerts', ['getError', 'getWarning', 'getSuccess']),
    ...mapGetters('tutorials', ['getState'])
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Lato;
  scroll-behavior: smooth;
}

body::-webkit-scrollbar {
  width: 0.5rem;
}
 
body::-webkit-scrollbar-track {
  background-color: rgb(62, 64, 70);
}
 
body::-webkit-scrollbar-thumb {
  background-color: rgb(83, 86, 94);
  border-radius: 1rem;
}

#app {
  width: 100%;
  height: auto;
  display: flex;
  background-color: rgb(62, 64, 70);
}

.swal-title {
  font-family: Roboto;
}
.swal-text {
  font-family: Roboto;
  margin-top: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  line-height: 1.5rem;
  text-align: justify;
}
.swal-footer {
  padding-top: 0.5rem;
  padding-bottom: 1rem;
}

// Transitions
.fade-enter {
  filter: blur(3px);
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.2s ease-in-out;
}

.fade-leave-to {
  filter: blur(3px);
}
</style>
